import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import moment from "moment/moment";
import Skeleton from "react-loading-skeleton";
import { Modal } from "react-bootstrap";
import axios from ".././axios-interceptor";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import Cookies from 'js-cookie';
import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  LOAN_REPAYMENT_BY_BUSINESS,
  STATUS_CLOSED,
  AUDITOR_ROLE,
} from "./../utilities";

const BusinesswithInvDetails = (props) => {
  let ltwo = props.loading;
  const navigate = useNavigate();
  let loandetails = props.loandetails;
  const [investorData] = useState(props.investorData);
   
  let businessDetails = loandetails.business_details;
  
  let scheduleRepayment = loandetails.payment_details;
  let business_id = props.invData?.business_id;

  const [activeTab, setActiveTab] = useState("home-tab");
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Admin")) {
    navigate("/adminlogin");
  }
}, []);


  const gotToSingleInv = () => {
    props.hide();
    props.showcontent();
  };
  const columns = [
    { title: "Profit Amount Payment", field: "tenure_amount" },
    { title: "Tenure Date", field: "tenure_date" },
    { title: "Amount Paid", field: "paid_amount" },
  ];

  const handleSorttwo = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...scheduleRepayment].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    scheduleRepayment = sortedData;
  };

  let EachLoanData =
    props.loandetails !== "" &&
    props.loandetails !== undefined &&
    props.loandetails !== null
      ? props.loandetails
      : "No Data";

  let loanhistorydata = EachLoanData.loan_history;
  let loan_history_array = [];
  loanhistorydata?.map((each_history_record) => {
    //NEW LOAN REQUEST LIST
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      !each_history_record.is_investor_interested &&
      !each_history_record.is_admin_sent_terms_to_business
    ) {
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_investor_interested === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_admin_sent_terms_to_business === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_PROCESSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="style_loan_txt">
          Admin paid the requested loan amount{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to business on{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="">
          Business repaid for the month of{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {moment(each_history_record.tenure_date).format("MMMM")}
          </span>
          , loan tenure amount{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to admin on{" "}
          <span style={{ color: "black" }} className=" fw-bold">
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_CLOSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business repaid the loan successfully";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
  });

  const [investorFullProfModal, setInvestorFullProfModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [businessProfileData, setBusinessProfileData] = useState([]);
  const [kycDocuments, setKYCDocuments] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);

  const handleVieFullProfileMethod = () => {
    axios
      .post(base_url + "business-master/get_business_by_business_id", {
        business_id: business_id,
      })
      .then((res) => {
        let data = res.data.data;
        if (data === "") {
          setIsLoading(true);
        } else {
          if (
            data.business_image_url == null ||
            data.business_image_url == ""
          ) {
            data.business_image_url =
              "https://media.istockphoto.com/id/1256603011/photo/business-network-concept-customer-support-shaking-hands.jpg?s=612x612&w=0&k=20&c=uRYJ6c2EyNO92w0wQlCScEVwbdoyHaXzfIxw1q7zNLA=";
          }
          setBusinessProfileData(data);
          setKYCDocuments(data.list_of_kyc_documents);
          setLoanHistory(data.business_loans_history);
        }
      });
    setInvestorFullProfModal(true);
  };

  return (
    <div className=" mb-3">
      <div className="row pt-0 pb-3 p-5">
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
            <h5 className="admin_serv mb-1" onClick={gotToSingleInv}>
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls"
              />
              &nbsp; Back
            </h5>
          </div>
        </div>

        <Card>
          <div class="row">
            <div className="col p-3 justify-content-between invFullprofInvid">
                <div className="">
                  <h5 className="mb-1">{investorData?.investor_name}</h5>
                  <h4>{investorData?.investor_reference_no}</h4>
                  <div className="singInvabout">{investorData?.about}</div>
                </div>
                <div className="  d-flex gap-3 mt-2">
                  <div className=" mb-3 mb-md-0 b_style_new ms-0">
                    <span>Total committed</span>
                    <p className="p_style">
                      ${" "}
                      {Number(
                        investorData?.committed_principal
                      ).toLocaleString()}
                    </p>
                  </div>
                  <div className=" mb-3 mb-md-0 n_style_new">
                    <span>Total Invested</span>
                    <p className="p_style">
                      $ {Number(investorData?.total_invested).toLocaleString()}
                    </p>
                  </div>
                  <div className=" mb-3 mb-md-0 g_style_new">
                    <span>Total Available</span>
                    <p className="p_style">
                      $ {Number(investorData?.total_available).toLocaleString()}
                    </p>
                  </div>
                </div>
            </div>

            <div className="col-lg-3 d-flex align-self-center trqteqter pe-3">
              <img
                width={304}
                height={165}
                src={investorData?.investor_image_url}
                alt=""
              />
            </div>
          </div>
        </Card>
      </div>

      <Card className="bg-body me-5 ms-5">
        <div className="row p-3 d-flex ">
          <div className="d-flex">
            <div className="col me-4">
              <h4>{businessDetails?.business_name}</h4>
              <p>
                {" "}
                <b className="text-black">Industry </b>
                {businessDetails?.business_type}
              </p>
              <p className="aboutBusiness">
                <b>About Business</b> {businessDetails?.about}
              </p>
            </div>
            <div className="bwidviewprofile " style={{
    pointerEvents: props.roleCode === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.roleCode === AUDITOR_ROLE ? 0.5 : 1,
  }}>
              <span onClick={handleVieFullProfileMethod}>
                View Full Profile {">"}
              </span>
            </div>
            <div className="">
              <div className="row trqteqter">
                <div className="col text-end">
                  <img
                    width={304}
                    height={165}
                    src={businessDetails?.business_image_url}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card className="row ms-5 me-5 mt-3 bg-white p-3 inwithbusdetlastcard">
        <div className=" p-0 mt-3">
          <div className="row ">
            <div className="col-lg-1 me-3">
              <div className="mb-3">
                <p className="text_st ">Loan Ref No</p>
                <span className="bolder_text ">
                  {loandetails.loan_reference_number === undefined ||
                  loandetails.loan_reference_number === ""
                    ? "-"
                    : loandetails.loan_reference_number}
                </span>
              </div>
            </div>

            <div className="col me-3">
              <div className="mb-3">
                <p className="text_st ">Loan Type</p>
                <span className="bolder_text ">
                  {loandetails.loan_type_name === undefined ||
                  loandetails.loan_type_name === ""
                    ? "-"
                    : loandetails.loan_type_name}
                </span>
              </div>
            </div>

            <div className="col-lg-2 me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Principal Amount</p>
                <span className="bolder_text ">
                  {" "}
                  <div>
                    {loandetails.admin_request_loan_amount === undefined ||
                    loandetails.admin_request_loan_amount === ""
                      ? "-"
                      : loandetails.admin_request_loan_currency ===
                        LOAN_CURRENCY_TYPE_BHD
                      ? "BHD "
                      : loandetails.admin_request_loan_currency ===
                        LOAN_CURRENCY_TYPE_USD
                      ? "$ "
                      : ""}{" "}
                    {loandetails.admin_request_loan_amount === undefined ||
                    loandetails.admin_request_loan_amount === ""
                      ? "-"
                      : Number(
                          loandetails.admin_request_loan_amount
                        ).toLocaleString() !== undefined ||
                        !isNaN(
                          Number(
                            loandetails.admin_request_loan_amount
                          ).toLocaleString()
                        ) ||
                        Number(
                          loandetails.admin_request_loan_amount
                        ).toLocaleString() !== ""
                      ? Number(
                          loandetails.admin_request_loan_amount
                        ).toLocaleString()
                      : "-"}
                  </div>
                </span>
              </div>
            </div>

            <div className="col-lg-2 me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Requested Tenure Period</p>
                <span className="bolder_text ">
                  {loandetails.final_tenure === undefined ||
                  loandetails.final_tenure === ""
                    ? "-"
                    : loandetails.final_tenure === 1
                    ? loandetails.final_tenure + " Month"
                    : loandetails.final_tenure > 1
                    ? loandetails.final_tenure + " Months"
                    : "-"}
                </span>
              </div>
            </div>

            <div className="col-md-1 me-2 ps-3 text-center">
              <div className="mb-3">
                <p className="text_st ">Rate</p>
                <span className="bolder_text ">
                  {loandetails.bennefin_roi !== undefined ||
                  loandetails.bennefin_roi !== null ||
                  loandetails.bennefin_roi !== ""
                    ? loandetails.bennefin_roi + "%"
                    : "-"}
                </span>
              </div>
            </div>

            <div className="col me-2 ps-3">
              <div className="mb-3 loanpurpose_txt">
                <p className="text_st ">Loan Purpose</p>
                <span className="bolder_text ">
                  {loandetails.loan_purpose === "" ||
                  loandetails.loan_purpose === undefined ||
                  loandetails.loan_purpose === null
                    ? "-"
                    : loandetails.loan_purpose}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="row  mt-3">
          <div className="col admin_each_ln_pop">
            <ul className="nav nav-tabs d-flex gap-3" id="myTab" role="tablist">
              <li className="nav-item-aelb" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "home-tab" ? "active" : ""
                  } p-1`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="home-tab-pane"
                  aria-selected="true"
                  onClick={() => setActiveTab("home-tab")}
                >
                  <h6 className="">Schedule Of Return Payments</h6>
                  {activeTab === "home-tab" && (
                    <img
                      style={{ marginTop: "-43px" }}
                      src="./images/polygondown.svg"
                      alt=""
                    />
                  )}
                </button>
              </li>
              <li className="nav-item-aelb" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "profile-tab" ? "active" : ""
                  } p-1`}
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="profile-tab-pane"
                  aria-selected="false"
                  onClick={() => setActiveTab("profile-tab")}
                  disabled={props.roleCode===AUDITOR_ROLE}
                >
                  <h6 className="">Loan History</h6>
                  {activeTab === "profile-tab" && (
                    <img
                      style={{ marginTop: "-43px" }}
                      src="./images/polygondown.svg"
                      alt=""
                    />
                  )}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="tab-content col-lg-6" id="myTabContent">
          <div
            className="tab-pane fade show active  "
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex="0"
          >
            <div className="newinvinteresttable-style">
              <Table
                striped
                // bordered
                className=""
              >
                <thead className="all_inv_table_head">
                  <tr>
                    {columns.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSorttwo(column.field)}
                          >
                            {ltwo ? (
                              <Skeleton width={100} height={15} />
                            ) : (
                              <div className="text-black text-center">
                                {" "}
                                {column.title}&#9662;
                              </div>
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {scheduleRepayment?.map((data, index) => {
                    return (
                      <tr key={index} className="new_inv_interst_table">
                        <td>
                          {data.tenure_amount == undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div>
                                  {data.admin_request_loan_currency ===
                                  LOAN_CURRENCY_TYPE_BHD
                                    ? "BHD "
                                    : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_USD
                                    ? "$ "
                                    : ""}{" "}
                                  {Number(data.tenure_amount).toLocaleString()}
                                </div>
                              )}
                            </div>
                          )}
                        </td>

                        <td>
                          {data.tenure_date == undefined ? (
                            "-"
                          ) : ltwo ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <div>
                              {moment(data.tenure_date).format("DD MMM YYYY")}
                            </div>
                          )}
                        </td>
                        <td>
                          {data.paid_amount == undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div>
                                  {data.admin_request_loan_currency ===
                                  LOAN_CURRENCY_TYPE_BHD
                                    ? "BHD "
                                    : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_USD
                                    ? "$ "
                                    : ""}{" "}
                                  {Number(data.paid_amount).toLocaleString()}
                                </div>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
          <div
            className="tab-pane fade loan_history_tab admin_each_history"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex="0"
          >
            <div className="">
              {loan_history_array.map((details) => {
                return (
                  <div key={details.message} className="row pt-0">
                    <div className="style_loan">
                      <img
                        className="me-2"
                        src="./images/circle.svg"
                        alt=""
                        srcSet=""
                        height={16}
                        width={16}
                      />
                      {moment(details.created_date_time).format(
                        "ddd , D MMM YYYY"
                      )}
                    </div>
                    <div className="style_loan_txt mb-4 ms-4 pe-5">
                      {details.message}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Card>

      <ViewBusinessFullProfile
        loanhistory={loanhistory}
        kycDocuments={kycDocuments}
        businessProfileData={businessProfileData}
        isLoading={isLoading}
        business_id={business_id}
        onHide={() => setInvestorFullProfModal(false)}
        investorFullProfModal={investorFullProfModal}
      />
    </div>
  );
};

export default BusinesswithInvDetails;

export const ViewBusinessFullProfile = (props) => {
  let {
    investorFullProfModal,
    onHide,
    business_id,
    isLoading,
    businessProfileData,
    kycDocuments,
    loanhistory,
  } = props;
  const handleClosePrfileModal = () => {
    onHide();
  };

  const navigate = useNavigate();
  const [uploadBtn, setUploadBtn] = useState(false);

  const [selectedFile, setSelectedFile] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  const titles = ["Type", "Uploaded By", "Actions"];

  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map((each_history_record) => {
    //NEW LOAN REQUEST LIST
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      !each_history_record.is_investor_interested &&
      !each_history_record.is_admin_sent_terms_to_business
    ) {
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_investor_interested === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_admin_sent_terms_to_business === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_PROCESSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="style_loan_txt">
          Admin paid the requested loan amount{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to business on{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="">
          Business repaid for the month of{" "}
          <span style={{ color: "black" }} className=" fw-bold">
            {moment(each_history_record.tenure_date).format("MMMM")}
          </span>
          , loan tenure amount{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to admin on{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_CLOSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business repaid the loan successfully";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
  });

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = businessProfileData.business_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const [imgFlag, setImgFlag] = useState(false);

  const [file, setUploadFile] = useState(null); //setUploadedUrl
  const [url, setUploadedUrl] = useState(null);
  const handleFileInputChange = (e) => {
    const fileName = e.target.files[0].name;
    const lastDotIndex = fileName.lastIndexOf(".");
    const fileExtension = fileName.substring(lastDotIndex + 1);
    if (
      fileExtension == "png" ||
      fileExtension == "jpeg" ||
      fileExtension == "jpg" ||
      fileExtension == "svg"
    ) {
      setImgFlag(true);
      setSelectedFile(URL.createObjectURL(e.target.files[0]));
      const url = URL.createObjectURL(e.target.files[0]);
      setImageUrl(url);
      setUploadFile(e.target.files[0].name);
      setUploadedUrl(e.target.files[0]);
    } else {
      toast.error("Please upload a profile in either SVG, PNG or JPEG format.", {
        toastId: 98,
      });
    }
  };

  let splitdata;
  let aboutdata = businessProfileData.about;
  if (aboutdata !== undefined) {
    splitdata = aboutdata.split(". ");
  }

  return (
    <Modal
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
      show={investorFullProfModal}
    >
      <Modal.Header
        onHide={handleClosePrfileModal}
        closeButton
        className="modal_title"
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Business Profile</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={`${"px-4 py-2"}`} style={{ height: "28rem" }}>
        {isLoading ? (
          <div className="historyLoader">
            <ThreeDots
              height="90"
              width="90"
              radius="9"
              color="3d79f3"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={isLoading}
            />
          </div>
        ) : (
          <div className="">
            <div className="profile_maindiv2">
              <div className="">
                <Card className=" d-flex justify-content-between">
                  <div className="row ">
                    <div className="col d-flex align-items-center justify-content-between">
                      <div className="busprofMaintitle">
                        <h4 className="">
                          {businessProfileData.business_name}
                        </h4>
                        <div className="busproftitle">
                          <p>
                            <b>Industry:</b> {businessProfileData.business_type}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col container image_uploadbtndiv">
                      <img
                        srcSet={
                          imgFlag
                            ? selectedFile
                            : businessProfileData.business_image_url
                        }
                        alt=""
                      />

                      <label className="Cpointer ">
                        {uploadBtn && (
                          <div>
                            <input
                              type="file"
                              onChange={(e) => handleFileInputChange(e)}
                            />
                            <span className="blue_btn">
                              <img src={"./images/upload.svg"} alt="" /> Upload
                              New
                            </span>
                          </div>
                        )}
                      </label>
                    </div>
                  </div>
                </Card>
              </div>
              <div className=" ">
                <div className="">
                  <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-settingsProf p-1 active"
                        id="About-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#About-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="About-tab-pane"
                        aria-selected="true"
                      >
                        <h3>About</h3>
                      </button>
                    </li>
                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="Financials-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Financials-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="Financials-tab-pane"
                        aria-selected="false"
                      >
                        <h3>KYC Documents</h3>
                      </button>
                    </li>

                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="loanhistory-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#loanhistory-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="loanhistory-tab-pane"
                        aria-selected="false"
                      >
                        <h3>Loan History</h3>
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content " id="myTabContent">
                  <div
                    className="tab-pane fade show active businessProf_about_inv"
                    id="About-tab-pane"
                    role="tabpanel"
                    aria-labelledby="About-tab"
                    tabIndex="0"
                  >
                    <p className="paragraph">
                      <p className="paragraph">
                        {splitdata?.map((sentence, index) => (
                          <p key={index}>{"\n" + sentence.trim() + "."}</p>
                        ))}
                      </p>
                    </p>
                  </div>
                  <div
                    className="tab-pane fade kycDocsBusinessprof"
                    id="Financials-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Financials-tab"
                    tabIndex="0"
                  >
                    <div className="row allinv_doc_tab_styl">
                      <div className="">
                        <Table responsive striped className=" my_loan_table ">
                          <thead>
                            <tr>
                              {titles.map((title, id) => (
                                <th key={id}>{title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {kycDocuments.map((doc, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {doc.document_type == undefined
                                      ? "-"
                                      : doc.document_type}
                                  </td>
                                  <td>
                                    {doc.created_by == undefined
                                      ? "-"
                                      : doc.created_by}
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-evenly">
                                      <div className="">
                                        <a
                                          style={{ display: "table-cell" }}
                                          href={doc.document_url}
                                          target="_blank"
                                        >
                                          <img src="./images/eye.svg" alt="" />
                                        </a>
                                      </div>
                                      <div
                                        className=" ps-3 Cpointer"
                                        onClick={() =>
                                          handleDownload(
                                            doc.document_url,
                                            doc.document_type
                                          )
                                        }
                                      >
                                        <img src="./images/down.svg" alt="" />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade  loanhistory_tab_prof"
                    id="loanhistory-tab-pane"
                    role="tabpanel"
                    aria-labelledby="loanhistory-tab"
                    tabIndex="0"
                  >
                    {loan_history_array.length === 0 ? (
                      <h3 className="text-center mt-4">
                        There are no previous closed loans for this Business
                      </h3>
                    ) : (
                      loan_history_array.map((details) => {
                        return (
                          <div key={details.message} className="row pt-0">
                            <div className="style_loan">
                              <img
                                className="me-2"
                                src="./images/circle.svg"
                                alt=""
                                srcSet=""
                                height={16}
                                width={16}
                              />
                              {moment(details.created_date_time).format(
                                "ddd, D MMM YYYY"
                              )}
                            </div>
                            <div className="style_loan_txt mb-4 ms-4 pe-5">
                              {details.message}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClosePrfileModal}
          >
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
